import { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa6";
import MUITable from "../../Common/MUITable";
import AddEditRfidCategory from "./AddEditRfidCategory";
import { TableLoader } from "../../Common/ShimmerLoader";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import isGHMC from "../../Common/helper/helpar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ExportRfidCategory } from "./ExportRfidCategory";
import { useRfidCategoryStore } from "./store/useRfidCategoryStore";
import { StatusBadge } from "../Rfid/utils/statusBadge";

const RfidCategory = () => {
  const isProd = isGHMC();
  const [showModal, setShowModal] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const {
    filteredRfidCategories,
    isLoading,
    filters,
    fetchRfidCategories,
    fetchAssetTypes,
    applyFilters,
    updateFilter,
  } = useRfidCategoryStore();

  useEffect(() => {
    fetchAssetTypes();
    fetchRfidCategories();
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    updateFilter(name, value);
    applyFilters();
  };

  const handleAdd = () => {
    setIsEditMode(false);
    setEditRow(null);
    setShowModal(true);
  };

  const handleEdit = (row) => {
    setShowModal(true);
    setIsEditMode(true);
    setEditRow(row);
  };

  const rfidCategoryColumns = [
    {
      label: "Asset Type",
      render: (row) => row.rfidTypeName || "N/A",
    },
    {
      label: "Asset Category",
      field: "categoryName",
    },
    {
      label: "Status",
      render: (row) => <StatusBadge isActive={row.isActive} compact />,
    },
    {
      label: "Actions",
      render: (row) => (
        <button
          className={`${isProd ? "edit-ghmc" : "edit-swm"}`}
          onClick={() => handleEdit(row)}
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
      ),
    },
  ];

  return (
    <>
      <div className="content text-start">
        <div className="page-content">
        <div className="d-flex justify-content-between align-items-center mt-3">
            <div>
              <h5 className="mb-1 fw-semibold">Asset Category Information</h5>
              
            </div>
            <div className="d-flex align-items-center">
            <button className="button-container" onClick={handleAdd} style={{ whiteSpace: "nowrap" }}>
  <FaPlus className="font-size-20 me-1" /> Add Asset Category
</button>
              <ExportRfidCategory rfidCategoryData={filteredRfidCategories} />
            </div>
          </div>
          <div className="card shadow mt-3">
            <div className="card-body">
              <div className="row align-items-end justify-content-start">
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      type="text"
                      name="searchTerm"
                      value={filters.searchTerm}
                      onChange={handleFilterChange}
                      placeholder="Search Asset Category"
                      className="form-control bg-white"
                    />
                  </div>
                </div>
              </div>
              <div>
                <MUITable loading={isLoading}
                  needSRNumber={true}
                  rows={filteredRfidCategories}
                  columns={rfidCategoryColumns}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddEditRfidCategory
        showModal={showModal}
        setShowModal={setShowModal}
        editRow={editRow}
        isEditMode={isEditMode}
      />
    </>
  );
};

export default RfidCategory;
